import { useTranslation } from "react-i18next";
import Chip from "./chip/Chip.jsx";

export function BooleanRenderer({ value }) {
  const { t } = useTranslation();

  return (value === true || value === 1 || value === "1")
    ? <Chip variant="success">{t("Yes", "Kyllä")}</Chip>
    : <Chip variant="error">{t("No", "Ei")}</Chip>;
}

export function BooleanFormatter({ value }) {
  const { t } = useTranslation();

  return (value === true || value === "1") ? t("Yes", "Kyllä") : t("No", "Ei");
}

/*
export function GridPageSizeSelector({ gridRef, gridDatasource }) {
  const { t } = useTranslation();

  return (
    <Form.Group as={Row} controlId="pageSize">
      <Form.Label column="sm">
        {t("ResultsOnPage", "Tuloksia sivulla")}
      </Form.Label>
      <Col md="auto">
        <Form.Select onChange={(e) => onPageSizeChanged(gridRef, gridDatasource, e)} defaultValue="25" style={{width:100}}>
          <option>25</option>
          <option>100</option>
          <option>250</option>
          <option>500</option>
          <option value="ALL">{t("All", "Kaikki")}</option>
        </Form.Select>
      </Col>
    </Form.Group>
  );
}

export function GridClientPageSizeSelector({ gridRef }) {
  const { t } = useTranslation();

  return (
    <Form.Group as={Row} controlId="pageSize">
      <Form.Label column="sm">
        {t("ResultsOnPage", "Tuloksia sivulla")}
      </Form.Label>
      <Col md="auto">
        <Form.Select onChange={(e) => onClientPageSizeChanged(gridRef, e)} defaultValue="25" style={{width:100}}>
          <option>25</option>
          <option>50</option>
          <option>100</option>
          <option>250</option>
          <option>500</option>
        </Form.Select>
      </Col>
    </Form.Group>
  );
}
*/
